import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Image,
  Input,
  InputNumber,
  Layout,
  Modal,
  Radio,
  Row,
  Space,
  Table,
  Tooltip,
  Typography,
  type FormProps,
} from 'antd';
import { useEffect, useState } from 'react';

import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DEFAULT_PAGE_SIZE } from 'antd/es/table/hooks/usePagination';
import moment from 'moment/moment';
import { useTranslation } from 'react-i18next';
import IconExclamationCircle from '../../assets/images/ExclamationCircle.svg';
import icEdit from '../../assets/images/ic-edit.svg';
import IcPlus from '../../assets/images/ic-plus.svg';
import IcUnLock from '../../assets/images/ic-unlock.svg';
import iconChecked from '../../assets/images/icon-checked.svg';
import icNope from '../../assets/images/trips/ic-nope.svg';
import TabsFilterStatus from '../../components/TabsFilterStatus/TabsFilterStatus';
import { Constant, TabType } from '../../config/constant';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  createTicket,
  getAllListRoute,
  getListTickets,
  updateStatusTicket,
  updateTicket,
} from '../../redux/slice/tickets/ticketsSlice';
import { formatPrice, handleGetUrlGuide } from '../../utils/helpers';
import './tickets.scss';

import type { GetProps } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import iconDelete from '../../assets/images/price-schedule/icon-delete.svg';
import iconSegment from '../../assets/images/price-schedule/icon-segment.svg';
import TutorialsVideo from '../../components/TutorialsVideo';
import {
  getPriceScheduleSegmentById,
  priceScheduleSelector,
  resetListPriceSchedule,
  resetListSegmentActive,
  setListSegmentActive,
} from '../../redux/slice/schdules/priceScheduleSlice';
import ModalPriceSegment from './ModalPriceSegment';

type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

dayjs.extend(customParseFormat);

enum UNIT {
  price,
  percent,
}

enum ADJUST {
  desc,
  asc,
  contact,
  notSale,
}

type FieldTypeForm = {
  adjust_up: number;
  adjust_down: number;
  range_date: string[];
  reason: string;
  route_id: number[];
  unit: UNIT;
  adjustType: ADJUST;
};

const { RangePicker } = DatePicker;

function SettingSchedulePrice() {
  const { listSegmentActive, listPriceSegmentDetail } = useAppSelector(priceScheduleSelector);
  const limit_pagination: any = window.localStorage.getItem('limit_pagination');
  const limitPagination = isNaN(Number(limit_pagination)) ? DEFAULT_PAGE_SIZE : Number(limit_pagination);
  const [limit, setLimit] = useState<number>(limitPagination || DEFAULT_PAGE_SIZE);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [page, setPage] = useState<number>(1);
  const [isUpdate, setIsUpdate] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [statusDetail, setStatusDetail] = useState(false);
  const [idTicketUpdate, setIdTicketUpdate] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isResetExpand, setIsResetExpand] = useState<boolean>(false);
  const [isCreate, setIsCreate] = useState<boolean>(false);
  const [isModalChooseSegment, setIsModalChooseSegment] = useState(false);
  const [activeTab, setActiveTab] = useState<TabType>(TabType.ALL);
  const listTutorials = useAppSelector((state) => state?.tutorials?.listTutorials);
  const [form] = Form.useForm();
  const unitValueWatch = Form.useWatch('unit', form);
  const adjustValueWatch = Form.useWatch('adjustType', form);
  const watchRangeDate = Form.useWatch('range_date', form);
  const pagination = useAppSelector((state) => state?.tickets?.pagination);
  const listTickets = useAppSelector((state) => state?.tickets?.listTickets);
  const loadingListTickets = useAppSelector((state) => state?.tickets?.loading);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const handleOpenCreate = () => {
    setOpenCreate(true);
    setIsUpdate(false);
    setIsCreate(true);
    dispatch(resetListSegmentActive());
    dispatch(resetListPriceSchedule());
  };

  const cancelModal = () => {
    setOpenCreate(false);
    setIsUpdate(false);
    form.resetFields();
    setIsResetExpand(true);
    dispatch(resetListSegmentActive());
    dispatch(resetListPriceSchedule());
    setIsCreate(false);
  };

  const handleCancelModalChooseSegment = () => {
    setIsModalChooseSegment(false);
    // dispatch(resetListSegmentActive());
    // dispatch(resetListPriceSchedule());
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
  };

  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      form.scrollToField(firstErrorField.name);
    }
  };

  const handleUpdate = (record: any) => {
    setIdTicketUpdate(record?.id);
    setOpenCreate(true);
    setIsUpdate(true);
    dispatch(getPriceScheduleSegmentById(record?.id));
    setStatusDetail(record?.status);
    setIsCreate(false);
  };

  const onChangePage = (page: number, pageSize: number) => {
    if (pagination?.per_page !== pageSize) {
      setPage(Constant.DEFAULT_PAGE);
      setLimit(pageSize);
      return;
    }
    setPage(page);
  };

  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    return current && current < dayjs().endOf('day');
  };

  const handleChangeTab = (key: TabType) => {
    setActiveTab(key);
    setPage(1);
  };

  const handleRemoveSegment = (segmentItem: any, segment: any) => {
    const updatedList = listSegmentActive
      ?.map((schedule: any) => {
        if (schedule?.schedule_id === segmentItem?.schedule_id) {
          const updatedSegments = schedule?.segments?.filter((s: any) => s?.segment_id !== segment?.segment_id);
          form.setFieldsValue({
            [segmentItem.schedule_id]: updatedSegments.map((s: any) => s?.segment_id),
          });

          return {
            ...schedule,
            segments: updatedSegments,
          };
        }
        return schedule;
      })
      ?.filter((schedule: any) => schedule?.segments?.length > 0);
    dispatch(setListSegmentActive(updatedList));
  };

  const handleOkModal = async () => {
    setIsModalVisible(false);
    if (statusDetail) {
      setStatusDetail(false);
    } else {
      setStatusDetail(true);
    }
    const response = await dispatch(updateStatusTicket({ id: idTicketUpdate, status: !statusDetail }));
    if (response?.payload?.success) {
      dispatch(
        getListTickets({
          page,
          limit,
          status: activeTab === TabType.ALL ? null : activeTab === TabType.ACTIVE ? true : false,
        }),
      );
      setOpenCreate(false);
      form.resetFields();
    } else {
      if (response?.payload?.response?.data?.errors) {
        const listErrors = response?.payload?.response?.data?.errors;
        form.setFields(
          Object.keys(listErrors).map((fieldName) => ({
            name: fieldName,
            errors: [listErrors[fieldName]],
          })),
        );
      }
    }
  };

  const columns: any = [
    {
      title: 'Lý do',
      dataIndex: 'reason',
      key: 'reason',
      render: (_: any, record: any) => (
        <Space size="middle">
          {record.status ? (
            <FontAwesomeIcon icon={faCircle} className="green" size="xs" />
          ) : (
            <FontAwesomeIcon icon={faCircle} className="danger" size="xs" />
          )}
          <Typography className="text-color">{record?.reason}</Typography>
        </Space>
      ),
    },
    {
      title: 'Từ ngày',
      dataIndex: 'start_date',
      key: 'start_date',
      sorter: (a: any, b: any) => moment(a.start_date).unix() - moment(b.start_date).unix(),
      render: (date: any) => moment(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Đến ngày',
      dataIndex: 'end_date',
      key: 'end_date',
      width: '10%',
      render: (date: any) => moment(date).format('DD/MM/YYYY'),
      sorter: (a: any, b: any) => moment(a.end_date).unix() - moment(b.end_date).unix(),
    },
    {
      title: 'Tăng',
      dataIndex: 'asc',
      key: 'asc',
      render: (_: any, record: any) =>
        !record?.is_price_contact && !record?.not_sale
          ? record?.is_increase
            ? `${record?.percent ? record?.percent + '%' : formatPrice(record?.price, _, `,`) + ' VND'}`
            : '--'
          : '--',
    },
    {
      title: 'Giảm',
      dataIndex: 'desc',
      key: 'desc',
      render: (_: any, record: any) =>
        !record?.is_price_contact && !record?.not_sale
          ? record?.is_increase
            ? '--'
            : `${record?.percent ? record?.percent + '%' : formatPrice(record?.price, _, `,`) + ' VND'}`
          : '--',
    },
    {
      title: 'Giá liên hệ',
      dataIndex: 'is_price_contact',
      key: 'is_contact',
      render: (_: any, record: any) => (!record?.is_price_contact ? '--' : <img src={iconChecked} alt="" />),
    },
    {
      title: 'Không bán',
      dataIndex: 'not_sale',
      key: 'not_sale',
      render: (text: boolean) => (!text ? '--' : <img src={iconChecked} alt="" />),
    },
    {
      title: 'Chức năng',
      dataIndex: 'action',
      key: 'action',
      render: (_: any, record: any) => (
        <Space size="middle">
          <Tooltip title="Chỉnh sửa">
            <button className="Table__button__edit" onClick={() => handleUpdate(record)} type="button">
              <Image width={17} height={17} className="icon-edit mr-20" src={icEdit} preview={false} />
            </button>
          </Tooltip>
        </Space>
      ),
      align: 'center',
      width: '120px',
    },
  ];

  const onSubmit: FormProps<FieldTypeForm>['onFinish'] = async (values) => {
    const isIncrease = form.getFieldValue('adjustType') === ADJUST.asc;
    const isContact = form.getFieldValue('adjustType') === ADJUST.contact;
    const isNotSale = form.getFieldValue('adjustType') === ADJUST.notSale;
    let price: number | null = null;
    let percent: number | null = null;
    if (form.getFieldValue('unit') === UNIT.percent) {
      percent = isIncrease ? values?.adjust_up : values?.adjust_down;
    }
    if (form.getFieldValue('unit') === UNIT.price) {
      price = isIncrease ? values?.adjust_up : values?.adjust_down;
    }
    const payload = {
      reason: values?.reason,
      is_increase: isContact || isNotSale ? false : isIncrease,
      percent: isContact ? null : percent,
      price: isContact ? null : price,
      is_price_contact: isContact ? isContact : false,
      start_date: dayjs(values?.range_date?.[0]).format('YYYY-MM-DD'),
      end_date: dayjs(values?.range_date?.[1]).format('YYYY-MM-DD'),
      segments: listSegmentActive?.length
        ? listSegmentActive
            ?.map((segmentItem: any) => segmentItem?.segments?.map((item: any) => item?.segment_id))
            ?.flat()
        : [],
      not_sale: isNotSale ? isNotSale : false,
    };
    if (isUpdate) {
      const response = await dispatch(updateTicket({ ...payload, id: idTicketUpdate }));
      if (response?.payload?.success) {
        dispatch(
          getListTickets({
            page,
            limit,
            status: activeTab === TabType.ALL ? null : activeTab === TabType.ACTIVE ? true : false,
          }),
        );
        form.resetFields();
        setOpenCreate(false);
      } else {
        if (response?.payload?.response?.data?.errors) {
          const listErrors = response?.payload?.response?.data?.errors;
          form.setFields(
            Object.keys(listErrors).map((fieldName) => ({
              name: fieldName,
              errors: [listErrors[fieldName]],
            })),
          );
        }
      }
    } else {
      const response = await dispatch(createTicket(payload));
      if (response?.payload?.success) {
        dispatch(
          getListTickets({
            page,
            limit,
            status: activeTab === TabType.ALL ? null : activeTab === TabType.ACTIVE ? true : false,
          }),
        );
        form.resetFields();
        setOpenCreate(false);
      } else {
        if (response?.payload?.response?.data?.errors) {
          const listErrors = response?.payload?.response?.data?.errors;
          form.setFields(
            Object.keys(listErrors).map((fieldName) => ({
              name: fieldName,
              errors: [listErrors[fieldName]],
            })),
          );
        }
      }
    }
  };

  useEffect(() => {
    dispatch(getAllListRoute({ keyword: '' }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getListTickets({
        page,
        limit,
        status: activeTab === TabType.ALL ? null : activeTab === TabType.ACTIVE ? true : false,
      }),
    );
  }, [dispatch, activeTab, limit, page]);

  useEffect(() => {
    if (listPriceSegmentDetail && isUpdate) {
      dispatch(setListSegmentActive(listPriceSegmentDetail?.segments));
      form.setFieldsValue({
        reason: listPriceSegmentDetail?.reason,
        range_date: [dayjs(listPriceSegmentDetail?.start_date), dayjs(listPriceSegmentDetail?.end_date)],
        route_id: [
          {
            id: listPriceSegmentDetail?.route?.id,
            name: `${listPriceSegmentDetail?.route?.depart_point} - ${listPriceSegmentDetail?.route?.arrive_point}`,
          },
        ],
        adjustType: listPriceSegmentDetail?.not_sale
          ? ADJUST.notSale
          : listPriceSegmentDetail?.is_price_contact
          ? ADJUST.contact
          : listPriceSegmentDetail?.is_increase
          ? ADJUST.asc
          : ADJUST.desc,
        adjust_down: listPriceSegmentDetail?.is_price_contact
          ? null
          : listPriceSegmentDetail?.is_increase
          ? null
          : listPriceSegmentDetail?.percent
          ? listPriceSegmentDetail?.percent
          : listPriceSegmentDetail?.price,
        adjust_up: listPriceSegmentDetail?.is_price_contact
          ? null
          : listPriceSegmentDetail?.is_increase
          ? listPriceSegmentDetail?.percent
            ? listPriceSegmentDetail?.percent
            : listPriceSegmentDetail?.price
          : null,
        unit: listPriceSegmentDetail?.is_price_contact
          ? null
          : listPriceSegmentDetail?.price
          ? UNIT.price
          : UNIT.percent,
      });
    }
  }, [dispatch, listPriceSegmentDetail, isUpdate]);

  return (
    <Layout className="min-vh-70 list-ticket">
      <Card>
        <TabsFilterStatus activeTab={activeTab} onChangeTab={handleChangeTab} />
        <Row className="fw-500 mt-4 mx-3 mb-3 d-flex justify-content-between">
          <Button type="primary" className={'btn-success height-btn-40'} onClick={handleOpenCreate}>
            <Image src={IcPlus} preview={false} className="mb-1 pe-2" />
            {t('Thêm lịch tăng giảm giá vé')}
          </Button>
          <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 5)} />
        </Row>
        <Table
          locale={{
            triggerDesc: 'Sắp xếp tăng dần',
            triggerAsc: 'Hủy sắp xếp',
            cancelSort: 'Sắp xếp giảm dần',
          }}
          dataSource={listTickets?.length > 0 ? listTickets : []}
          rowKey="id"
          rowClassName={(record) => (record?.status ? '' : 'bg-disabled')}
          pagination={{
            total: pagination?.total,
            current: page,
            pageSize: pagination?.per_page ?? limitPagination,
            position: ['bottomRight'],
            onChange: onChangePage,
            showSizeChanger: true,
          }}
          columns={columns}
          className="mx-3 list-trips price-schedule"
          loading={loadingListTickets}
        />
        <Modal
          centered
          className="create-ticket-setting Modal-ticket"
          open={openCreate}
          onOk={() => setOpenCreate(false)}
          onCancel={() => cancelModal()}
          styles={
            {
              // body: { maxHeight: '90vh', overflowY: 'auto', overflowX: 'hidden' },
            }
          }
          width={900}
          footer={[]}
          maskClosable={false}
        >
          <Flex align="center" justify="space-between" className="mr-20">
            <Typography.Title className="fs-20 fw-500 mb-0">Chi tiết thông tin lịch tăng giảm giá vé</Typography.Title>
            <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 5)} />
          </Flex>

          <Form
            className="mg-16 mt-30 fw-500 text-color-default"
            form={form}
            labelCol={{ xxl: 5, xl: 6, lg: 7, md: 24, sm: 24 }}
            requiredMark={false}
            onFinish={onSubmit}
            onFieldsChange={(_, allFields) => {
              scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
            }}
            colon={false}
          >
            <Row gutter={16}>
              <Col span={12}>
                <Col>
                  <span className="required">{t(`Lý do`)}</span>
                  <Form.Item<FieldTypeForm>
                    name="reason"
                    className="form_reason"
                    rules={[{ required: true, message: 'Vui lòng chọn lý do' }]}
                  >
                    <Input placeholder={t('Nhập lý do')} className="input-h40 rounded-lg" />
                  </Form.Item>
                </Col>
                <Form.Item className="d-none" name={'segments'} />

                <Col style={{ marginTop: '20px' }}>
                  <Form.Item<FieldTypeForm> name="adjustType" initialValue={ADJUST.asc}>
                    <Radio.Group size="small">
                      <Radio value={ADJUST.asc}>
                        <div>
                          <span className="text-color-default">Tăng</span>
                          <div
                            className={`form-item__adjust ${
                              adjustValueWatch === ADJUST.desc ||
                              adjustValueWatch === ADJUST.contact ||
                              adjustValueWatch === ADJUST.notSale
                                ? 'disabled'
                                : ''
                            }`}
                          >
                            <Flex
                              className="input-flex-container"
                              gap={0}
                              align="center"
                              vertical={false}
                              style={{ position: 'relative' }}
                            >
                              <Form.Item<FieldTypeForm>
                                name="adjust_up"
                                dependencies={['unit', 'adjustType']}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (getFieldValue('adjustType') === ADJUST.asc) {
                                        if (value) {
                                          if (getFieldValue('unit') === UNIT.percent) {
                                            if (value < 1)
                                              return Promise.reject(new Error('Giá trị tăng tối thiểu 1%'));
                                            if (value > 100)
                                              return Promise.reject(new Error('Giá trị tăng tối đa 100%'));
                                            return Promise.resolve();
                                          } else {
                                            if (value < 10000)
                                              return Promise.reject(new Error('Giá trị tăng tối thiểu 10,000VND'));
                                            if (value > 10000000)
                                              return Promise.reject(
                                                new Error('Giá trị tăng không vượt quá 10,000,000VND'),
                                              );
                                            return Promise.resolve();
                                          }
                                        } else {
                                          return Promise.reject(new Error('Vui lòng nhập giá trị tăng'));
                                        }
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  }),
                                ]}
                              >
                                <InputNumber<number>
                                  formatter={(value) => {
                                    if (unitValueWatch === UNIT.price) {
                                      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                    } else {
                                      return `${value}`;
                                    }
                                  }}
                                  className="input__price input-h40 d-flex items-center rounded-lg"
                                  controls={false}
                                  disabled={
                                    adjustValueWatch === ADJUST.desc ||
                                    adjustValueWatch === ADJUST.contact ||
                                    adjustValueWatch === ADJUST.notSale
                                  }
                                  placeholder="Nhập giá trị"
                                  parser={(value) => value?.replace(/\$\s?|(,*)/g, '') as unknown as number}
                                />
                              </Form.Item>
                              <div className="Modal__item__adjust input-h40 rounded-lg">
                                <Divider type="vertical" />
                                <Flex className="input-suffix-container" gap={6} align="center" vertical={false}>
                                  <Form.Item<FieldTypeForm> name="unit" initialValue={UNIT.percent}>
                                    <Radio.Group
                                      disabled={
                                        adjustValueWatch === ADJUST.desc ||
                                        adjustValueWatch === ADJUST.contact ||
                                        adjustValueWatch === ADJUST.notSale
                                      }
                                      size="small"
                                    >
                                      <Radio.Button value={UNIT.percent}>%</Radio.Button>
                                      <Radio.Button value={UNIT.price}>VND</Radio.Button>
                                    </Radio.Group>
                                  </Form.Item>
                                </Flex>
                              </div>
                            </Flex>
                          </div>
                        </div>
                      </Radio>
                      <Radio value={ADJUST.desc}>
                        <div>
                          <span className="text-color-default">Giảm</span>
                          <div
                            className={`form-item__adjust ${
                              adjustValueWatch === ADJUST.asc ||
                              adjustValueWatch === ADJUST.contact ||
                              adjustValueWatch === ADJUST.notSale
                                ? 'disabled'
                                : ''
                            }`}
                          >
                            <Flex
                              className="input-flex-container"
                              gap={0}
                              align="center"
                              vertical={false}
                              style={{ position: 'relative' }}
                            >
                              <Form.Item<FieldTypeForm>
                                name="adjust_down"
                                dependencies={['unit', 'adjustType']}
                                rules={[
                                  ({ getFieldValue }) => ({
                                    validator(_, value) {
                                      if (getFieldValue('adjustType') === ADJUST.desc) {
                                        if (value) {
                                          if (getFieldValue('unit') === UNIT.percent) {
                                            if (value < 1)
                                              return Promise.reject(new Error('Giá trị giảm tối thiểu 1%'));
                                            if (value > 100)
                                              return Promise.reject(new Error('Giá trị giảm tối đa 100%'));
                                            return Promise.resolve();
                                          } else {
                                            if (value < 10000)
                                              return Promise.reject(new Error('Giá trị giảm tối thiểu 10,000VND'));
                                            if (value > 10000000)
                                              return Promise.reject(
                                                new Error('Giá trị giảm không vượt quá 10,000,000VND'),
                                              );
                                            return Promise.resolve();
                                          }
                                        } else {
                                          return Promise.reject(new Error('Vui lòng nhập giá trị giảm'));
                                        }
                                      } else {
                                        return Promise.resolve();
                                      }
                                    },
                                  }),
                                ]}
                              >
                                <InputNumber<number>
                                  formatter={(value) => {
                                    if (unitValueWatch === UNIT.price) {
                                      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                    } else {
                                      return `${value}`;
                                    }
                                  }}
                                  className="input__price input-h40 rounded-lg items-center d-flex"
                                  controls={false}
                                  placeholder="Nhập giá trị"
                                  disabled={
                                    adjustValueWatch === ADJUST.asc ||
                                    adjustValueWatch === ADJUST.contact ||
                                    adjustValueWatch === ADJUST.notSale
                                  }
                                  parser={(value) => value?.replace(/\$\s?|(,*)/g, '') as unknown as number}
                                />
                              </Form.Item>
                              <div className="Modal__item__adjust input-h40">
                                <Divider type="vertical" />
                                <Flex className="input-suffix-container" gap={6} align="center" vertical={false}>
                                  <Form.Item<FieldTypeForm> name="unit" initialValue={form.getFieldValue('unit')}>
                                    <Radio.Group
                                      disabled={
                                        adjustValueWatch === ADJUST.asc ||
                                        adjustValueWatch === ADJUST.contact ||
                                        adjustValueWatch === ADJUST.notSale
                                      }
                                      size="small"
                                    >
                                      <Radio.Button value={UNIT.percent}>%</Radio.Button>
                                      <Radio.Button value={UNIT.price}>VND</Radio.Button>
                                    </Radio.Group>
                                  </Form.Item>
                                </Flex>
                              </div>
                            </Flex>
                          </div>
                        </div>
                      </Radio>
                      <Radio value={ADJUST.contact}>
                        <div>
                          <span className="text-color-default">Giá liên hệ</span>
                          <div
                            className={`form-item__adjust ${
                              adjustValueWatch === ADJUST.asc ||
                              adjustValueWatch === ADJUST.desc ||
                              adjustValueWatch === ADJUST.notSale
                                ? 'disabled'
                                : ''
                            }`}
                          >
                            <Flex
                              className="input-flex-container"
                              gap={0}
                              align="center"
                              vertical={false}
                              style={{ position: 'relative' }}
                            >
                              <div className="Modal__item__adjust">
                                <Divider type="vertical" />
                                <Flex className="input-suffix-container" gap={6} align="center" vertical={false}>
                                  <Form.Item<FieldTypeForm> name="unit" initialValue={form.getFieldValue('unit')}>
                                    <Radio.Group disabled={adjustValueWatch === ADJUST.asc} size="small"></Radio.Group>
                                  </Form.Item>
                                </Flex>
                              </div>
                            </Flex>
                          </div>
                        </div>
                      </Radio>
                      <Radio value={ADJUST.notSale}>
                        <div>
                          <span className="text-color-default">Không bán</span>
                          <div
                            className={`form-item__adjust ${
                              adjustValueWatch === ADJUST.asc ||
                              adjustValueWatch === ADJUST.desc ||
                              adjustValueWatch === ADJUST.contact
                                ? 'disabled'
                                : ''
                            }`}
                          >
                            <Flex
                              className="input-flex-container"
                              gap={0}
                              align="center"
                              vertical={false}
                              style={{ position: 'relative' }}
                            >
                              <div className="Modal__item__adjust">
                                <Divider type="vertical" />
                                <Flex className="input-suffix-container" gap={6} align="center" vertical={false}>
                                  <Form.Item<FieldTypeForm> name="unit" initialValue={form.getFieldValue('unit')}>
                                    <Radio.Group disabled={adjustValueWatch === ADJUST.asc} size="small"></Radio.Group>
                                  </Form.Item>
                                </Flex>
                              </div>
                            </Flex>
                          </div>
                        </div>
                      </Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col></Col>
              </Col>
              <Col span={12}>
                <span className="required">Thời gian áp dụng</span>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: 'Vui lòng nhập thời gian áp dụng',
                    },
                  ]}
                  className="fw-500 fs-16 text-color-default form_range_date"
                  name="range_date"
                >
                  <RangePicker
                    placeholder={['Từ ngày', 'Đến ngày']}
                    disabledDate={disabledDate}
                    format="DD/MM/YYYY"
                    className="input-h40 rounded-lg"
                  />
                </Form.Item>
                <div className="segment-list-block">
                  <Button
                    className="btn-choose-segment"
                    htmlType="button"
                    onClick={() => setIsModalChooseSegment(true)}
                    disabled={!watchRangeDate}
                  >
                    Chọn chặng áp dụng
                  </Button>
                  {listSegmentActive?.length
                    ? listSegmentActive?.map((segmentItem: any) => (
                        <div key={segmentItem?.schedule_id} className="mt-2">
                          <div className="gap-x-8 d-flex items-center">
                            <img src={iconSegment} alt="" className="mt-1" />
                            <p className="fs-14 fw-600 text-black mt-1">
                              {`${segmentItem?.route?.depart} - ${
                                segmentItem?.route?.arrive
                              } (${segmentItem?.depart_time?.slice(0, 5)})`}
                            </p>
                          </div>
                          <div className="segment-block-item">
                            {segmentItem?.segments?.length
                              ? segmentItem?.segments?.map((segment: any, index: number) => (
                                  <div key={index} className="d-flex items-center justify-between  mt-2">
                                    <p className="fs-14 fw-500 label-segment">{`${segment?.start_location} - ${segment?.end_location}`}</p>
                                    <button
                                      onClick={() => handleRemoveSegment(segmentItem, segment)}
                                      className="border-none bg-transparent"
                                      type="button"
                                    >
                                      <img src={iconDelete} alt="" className="cursor-pointer" />
                                    </button>
                                  </div>
                                ))
                              : ''}
                          </div>
                        </div>
                      ))
                    : ''}
                </div>
              </Col>
            </Row>

            <div className={`z-index1200 mt-5 d-flex ${isUpdate ? 'justify-content-between' : 'justify-content-end'}`}>
              {isUpdate && (
                <div className="d-flex justify-content-start">
                  {statusDetail ? (
                    <Button
                      className="btn-block-red h-btn-48"
                      danger
                      type="primary"
                      htmlType="button"
                      onClick={() => setIsModalVisible(true)}
                    >
                      <Image src={icNope} preview={false} className="pb-1 pe-2" />
                      {t('Khóa lịch tăng giảm giá vé')}
                    </Button>
                  ) : (
                    <Button
                      className="btn-active-green h-btn-48"
                      type="primary"
                      htmlType="button"
                      onClick={() => setIsModalVisible(true)}
                    >
                      <Image src={IcUnLock} preview={false} className="pb-1 pe-2" />
                      {t('Mở khóa lịch tăng giảm giá vé')}
                    </Button>
                  )}
                </div>
              )}
              <div className={`${isUpdate ? '' : ''}`}>
                <Button
                  key="cancel"
                  className={`${isUpdate ? 'w-160' : 'w-200'} h-btn-48`}
                  onClick={() => cancelModal()}
                >
                  {t('Đóng')}
                </Button>
                <Button
                  key="ok"
                  type="primary"
                  style={{ marginLeft: '16px' }}
                  className={`${isUpdate ? 'w-160' : 'w-200'} mr-0 ml-1 h-btn-48 btn-success`}
                  htmlType="submit"
                >
                  {t('Lưu')}
                </Button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal
          title={
            <Flex align="center">
              <Image preview={false} width={22} height={22} src={IconExclamationCircle} alt="Icon Exclamation Circle" />
              <p style={{ marginLeft: '16px', marginBottom: 0 }}>
                {statusDetail ? 'Khóa lịch tăng giảm giá vé' : 'Mở khóa lịch tăng giảm giá vé'}
              </p>
            </Flex>
          }
          open={isModalVisible}
          onCancel={handleCancelModal}
          onOk={handleOkModal}
          okText={statusDetail ? <p>Khóa ngay</p> : <p>Mở khóa ngay</p>}
          cancelText="Trở lại"
        >
          <p style={{ paddingLeft: '38px' }}>
            {statusDetail
              ? 'Bạn đang thao tác khóa lịch tăng giảm giá vé này, bạn có chắc chắn muốn khóa?'
              : 'Bạn đang thao tác mở khóa lịch tăng giảm giá vé này, bạn có chắc chắn muốn mở khóa?'}
          </p>
        </Modal>
        <ModalPriceSegment
          modalOpen={isModalChooseSegment}
          onCancel={handleCancelModalChooseSegment}
          onOk={() => {}}
          okText={'Lưu'}
          cancelText={'Đóng'}
          watchRangeDate={watchRangeDate}
          isUpdate={isUpdate}
          isResetExpand={isResetExpand}
          isCreate={isCreate}
        />
      </Card>
    </Layout>
  );
}

export default SettingSchedulePrice;
